(function (angular) {
    'use strict';

    angular.module('broadcast')

        .component('step2', {
            bindings: {
                forms: "="
            },
            controller: ["$rootScope", "$q", "$scope", "broadcastWizardService", "utilService", "WizardHandler", "uploadFileService", "audienceCreatorService", "$timeout", "$sce", "sharedDataService", "whatsAppServices", "$stateParams", "whatsAppSharedService",
                function ($rootScope, $q, $scope, broadcastWizardService, utilService, WizardHandler, uploadFileService, audienceCreatorService, $timeout, $sce, sharedDataService, whatsAppServices, $stateParams, whatsAppSharedService) {

                    // ALL of the step components instantiate when we enter the wizard ...

                    var ctrl = this;
                    ctrl.apiSpaceId = $stateParams.pickedApiSpaceId;

                    /**
                     * 
                     */
                    ctrl.$onInit = function () {
                        ctrl.smsInfo = { charCount: 0, msgCount: 0 }
                    }

                    /**
                     * 
                     */
                    ctrl.pickTestAudience = function (audience) {
                        ctrl.bws.step2Model.testAudience = audience;
                    }

                    /**
                     * 
                     */
                    ctrl.getTestAudienceLabel = function () {
                        return ctrl.bws.step2Model.testAudience ? ctrl.bws.step2Model.testAudience.name : "Test audience";
                    }

                    ctrl.bws = broadcastWizardService;

                    ctrl.emojitextareaPaste = function(index){
                        $rootScope.$broadcast( "paste", {id: 'text-input',
                        text: "{{profile." + ctrl.bws.profileSchema[index].path + "}}" });
                    }
                    
                    ctrl.onKeyDown = function (event, isOpen) {

                        if (!event.shiftKey && event.keyCode == 13 && isOpen){
                            event.preventDefault();
                        }
                    }

                    ctrl.isMergePopoverOpen = false;
                    ctrl.mergePopoverTemplete = 'components/toolkit/broadcast/templates/attachments/properties.html';
                    ctrl.hsmPropertiesPopoverTemplete = 'components/toolkit/broadcast/templates/hsmProperties.html';

                    ctrl.canAddMore = function () {	
                        if (ctrl.bws.step1Model.channel === 'sms') {	
                            return false;	
                        }	
                        return true;	
                    }
                    
                    ctrl.smsInfo = {}

                    if (!ctrl.bws.step2Model) {
                        ctrl.bws.step2Model = {};
                    }

                    if (!ctrl.bws.step2Model.messageParts) {
                        ctrl.bws.step2Model.messageParts = [];
                    }

                    //handling supported types
                    ctrl.typeSupported = function (type){
                        var mappings = sharedDataService.getTypesMapping()[type];
                        if(mappings){
                            return sharedDataService.checkIfAnyTypeSupported(mappings, ctrl.bws.step1Model.channel);
                        } else {
                            return sharedDataService.checkIfTypeSupported(type, ctrl.bws.step1Model.channel);
                        }
                    }

                     function getSupportedTypes(type){
                        var mappings = sharedDataService.getTypesMapping()[type];
                        return sharedDataService.getSupportedTypes(mappings, ctrl.bws.step1Model.channel);
                    }

                    /**
                     * 
                     */
                    ctrl.onSmsOriginatorChanged = function () {
                        ctrl.bws.step2Model.from = "";
                    }

                    /**
                     * 
                     */
                    ctrl.pickHsm = function(hsm){
                        ctrl.bws.step2Model.hsmParams = {};
                        ctrl.bws.step2Model.hsmLanguageCodes = Object.keys(hsm.messages);
                        ctrl.bws.step2Model.hsmLanguageCode = ctrl.bws.step2Model.hsmLanguageCodes[0];
                        ctrl.bws.step2Model.hsm = hsm;

                        ctrl.pickLanguage();
                    }
                    //TODO check save and add it to service that starts it

                    ctrl.pickLanguage = function(){
                        let message = ctrl.bws.step2Model.hsm.messages[ctrl.bws.step2Model.hsmLanguageCode];
                        ctrl.bws.step2Model.hsmPossibleParams = message.match(/{{\d+}}/g) || [];
                        let setupParams = Object.keys(ctrl.bws.step2Model.hsmParams);
                        let possibleLength = ctrl.bws.step2Model.hsmPossibleParams.length;
                        if(setupParams.length > possibleLength){
                            for(let paramIndex in setupParams){
                                if(parseInt(paramIndex) >= possibleLength){
                                    delete ctrl.bws.step2Model.hsmParams[setupParams[paramIndex]];
                                }
                            }
                        }
                        ctrl.bws.step2Model.hsmPossibleParams = _.uniq(ctrl.bws.step2Model.hsmPossibleParams);
                    }

                    ctrl.pickHsmProperty = function(value, index){
                        ctrl.bws.step2Model.hsmParams[index] = value;
                    }


                    ctrl.messagePreview = function(){
                        return !ctrl.bws.step2Model.hsm ? "" : whatsAppSharedService.hsmPreview(ctrl.bws.step2Model.hsm.messages[ctrl.bws.step2Model.hsmLanguageCode], ctrl.bws.step2Model.hsmParams);
                    }

                    /**
                     * 
                     */
                    ctrl.getWhatsAppData = function () {
                        if(!ctrl.whatsAppProfileSchema){
                            ctrl.whatsAppProfileSchema = ctrl.bws.profileSchema.map(function(schema){
                                return {
                                    name: schema.name,
                                    path: "{{profile." + schema.path + "}}"
                                }
                            });
                        }
                        if(!ctrl.bws.hsms.length){
                            return whatsAppServices.getHsms(ctrl.apiSpaceId).then(function(result){
                                ctrl.bws.hsms = result;
                                delete ctrl.bws.step2Model.hsm;
                            });
                        }
                    }
                    if(ctrl.bws.step1Model.channel === "whatsApp" || (ctrl.bws.whatsAppConfigurations && ctrl.bws.whatsAppConfigurations.length)){
                        if(ctrl.bws.whatsAppConfigurations.length === 1 && !ctrl.bws.step2Model.from){
                            ctrl.bws.step2Model.from = ctrl.bws.whatsAppConfigurations[0].phoneNumber;
                        }
                        ctrl.getWhatsAppData().then(function(){
                            if(ctrl.bws.hsms.length){
                                ctrl.bws.step2Model.hsm = ctrl.bws.hsms.find(function(hsm){
                                    return hsm.templateName === ctrl.bws.step2Model.tempTemplateName
                                });
                                ctrl.bws.step2Model.hsmLanguageCodes = Object.keys(ctrl.bws.step2Model.hsm.messages);
                                if(ctrl.bws.step2Model.hsmParams){
                                    ctrl.pickLanguage();
                                }
                            }
                        });
                    }

                    /**
                     * 
                     */
                    ctrl.addTextPart = function () {
                        ctrl.bws.step2Model.messageParts.push({
                            type: "text/plain",
                            data: ctrl.newText,
                            id: utilService.uuid()
                        });
                        ctrl.newText = "";
                        $timeout(function () {
                            $rootScope.$broadcast("newMessageRendered");
                        }, 0);
                    }

                    /**
                     * 
                     */
                    ctrl.addImagePart = function () {

                        uploadFileService.uploadFile(null, false, getSupportedTypes('media')).then(function (data) {

                            ctrl.bws.step2Model.messageParts.push({
                                type: data.type,
                                url: data.url,
                                size: data.size,
                                name: data.name,
                                id: utilService.uuid()
                            });
                        });
                    }


                    /**
                     * 
                     */
                    ctrl.removePart = function (part) {
                        var index = ctrl.bws.step2Model.messageParts.indexOf(part);
                        if (index >= 0) {
                            var part = ctrl.bws.step2Model.messageParts[index];
                            ctrl.bws.step2Model.messageParts.splice(index, 1);
                        }


                        if (ctrl.bws.step1Model.channel === 'sms') {
                            // reset the sms info
                            ctrl.smsInfo = { charCount: 0, msgCount: 0 }
                        }
                    }

                    ctrl.editPart = function (part) {
                        //adding 1 to be able to check for editingPart existence
                        ctrl.editingPartIndex = ctrl.bws.step2Model.messageParts.indexOf(part) + 1;
                        ctrl.lastText = ctrl.newText;
                        ctrl.newText = part.data;
                    }

                    ctrl.saveEditingPart = function () {
                        ctrl.bws.step2Model.messageParts[ctrl.editingPartIndex - 1].data = ctrl.newText;
                        ctrl.newText = ctrl.lastText;
                        delete ctrl.editingPartIndex;
                    }

                    ctrl.cancelEditingPart = function () {
                        delete ctrl.editingPartIndex;
                        ctrl.newText = ctrl.lastText;
                    }



                    ctrl.smsOriginatorTypes = [{
                        name: "Name",
                        id: "ALPHA_ORIGINATOR"
                    }, {
                        name: "Pool Number",
                        id: "POOL_NUMBER"
                    }];

                    ctrl.disableSend = function () {
                        if (ctrl.bws.step1Model.channel === 'sms' && ctrl.bws.step2Model.messageParts.length) {
                            return true;
                        }
                        return false;
                    }

                    // user has some long numbers ...
                    if (broadcastWizardService.dedicatedNumbers.length) {
                        ctrl.smsOriginatorTypes.unshift({
                            name: "Virtual Mobile Number",
                            id: "DEDICATED_LONG_NUMBER"
                        });
                    }

                    if (broadcastWizardService.shortcodes.length) {
                        ctrl.smsOriginatorTypes.push({
                            name: "Shortcodes",
                            id: "SHORTCODES"
                        });
                    }


                    ctrl.popoverText = function () {
                        var text = "Select a tag that describes your message ...";
                        if (ctrl.bws.step2Model.messageTag) {
                            text = ctrl.bws.possibleFbTags.find(function (item) {
                                return ctrl.bws.step2Model.messageTag == item.tag
                            }).description;
                        }
                        return text;
                    }

                    ctrl.sendTest = function () {
                        broadcastWizardService.testBroadcast().then(function(){
                            broadcastWizardService.updateBroadcast();
                        });
                    };

                    ctrl.createTestAudience = function () {
                        var modalInstance = audienceCreatorService.createAudience(true);

                        return modalInstance.result
                            .then(function (audience) {
                                broadcastWizardService.testAudiences.push(audience);
                            });
                    };

                    ctrl.getSmsCharacterCount = function (model) {

                        if (ctrl.bws.step1Model.channel === 'sms') {
                            ctrl.smsInfo = utilService.msgCounter(model);
                        }
                    }

                    ctrl.initialiseCharacterCount = function () {

                        if (ctrl.bws.step2Model.messageParts.length) {
                            ctrl.smsInfo = utilService.msgCounter(ctrl.bws.step2Model.messageParts[0].data);
                        } else if (ctrl.newText) {
                            ctrl.smsInfo = utilService.msgCounter(ctrl.newText);
                        }

                    }

                    ctrl.bws.step2Model.additionExitValidation = function(){
                        return ctrl.bws.step1Model.channel === "whatsApp" ?  ctrl.bws.step2Model.hsm && ctrl.bws.step2Model.hsmLanguageCode && ctrl.bws.step2Model.hsmPossibleParams.length === Object.keys(ctrl.bws.step2Model.hsmParams).length && Object.values(ctrl.bws.step2Model.hsmParams).every(h => h) : true;
                    }
                    
                    function updateAndNavigate(navFunc) {

                        ctrl.showInvalid = true;

                        if ((ctrl.bws.step1Model.channel !== "whatsApp" && ctrl.forms.step2Form.$valid) || ctrl.bws.step2Model.additionExitValidation()) {
                            broadcastWizardService.updateBroadcast()
                                .then(function (succeeded) {
                                    if (succeeded) {
                                        navFunc();
                                    }
                                });
                        }
                    }

                    ctrl.prev = function () {
                        updateAndNavigate(WizardHandler.wizard("broadcastWizard").previous);
                    }

                    ctrl.next = function () {
                        updateAndNavigate(WizardHandler.wizard("broadcastWizard").next);
                    }


                }],
            templateUrl: 'components/toolkit/broadcast/templates/step2.html'

        })

})(window.angular);